import React, { useState, useEffect } from 'react';
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import './Purchases.css';
import api from '../Service/api';
import UniversalInvoicePrint from './UniversalInvoicePrint';

function SaleRevertStock() {
  // Loading states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingVendors, setLoadingVendors] = useState(false);
  
  const [invoiceNumber, setInvoiceNumber] = useState(0); 
  const [customerName, setCustomerName] = useState("");  
  const [rent, setRent] = useState(""); 
  const [generalDiscount, setGeneralDiscount] = useState(0); 
  const [customerList, setCustomerList] = useState([]);
  const [description, setDescription] = useState("");
  const [gstPercentage, setGstPercentage] = useState("");
  const [selectedCustomerBalance, setSelectedCustomerBalance] = useState(null);

  const [invoiceDate, setInvoiceDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const [products, setProducts] = useState([{
    productName: '', category: '', returnedQuantity: '', price: '',
    size: '', ktae: '', gram: '', boxSize: '', particular: '', length: ''
  }]);
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [printInvoice, setPrintInvoice] = useState(null);
  
  const printRef = useRef();
  const [canPrint, setCanPrint] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [invoiceImage, setInvoiceImage] = useState(null);
  
  const handleFileChange = (e) => {
    setInvoiceImage(e.target.files[0]);
  };
  
  useEffect(() => {
    const phone = localStorage.getItem("userPhone");
    if (!phone) return;
    api.get(`/authentication/userData/${phone}`)
      .then(res => setLoggedInUser(res.data.additionalDetail))
      .catch(err => console.error(err));
  }, []);

  const refreshCustomerList = async () => {
    try {
      const res = await api.get("/product/getAllCustomers");
      if (res.data.code === 1) {
        setCustomerList(res.data.additionalDetail);
      }
    } catch (err) {
      console.error("Error refreshing customer list", err);
    }
  };
  
  const handleCustomerChange = (e) => {
    const name = e.target.value;
    setCustomerName(name);
    const customer = customerList.find(c => c.customerName === name);
    if (customer && customer.currentBalance !== undefined) {
      setSelectedCustomerBalance(customer.currentBalance);
    } else {
      setSelectedCustomerBalance(null);
    }
  };

  const totalQuantity = products.reduce((sum, p) => {
    const qty = parseFloat(p.returnedQuantity);
    return sum + (isNaN(qty) ? 0 : qty);
  }, 0);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Invoice-${invoiceNumber}`,
  });
  
  const handlePrintClick = () => {
    if (!printInvoice) {
      alert("No invoice data to print");
      return;
    }
    handlePrint();
  };

  const refreshProductList = async () => {
    setLoadingProducts(true);
    try {
      const res = await api.get("/product/names-prices");
      if (res.data.code === 1) {
        setProductList(res.data.additionalDetail);
      }
    } catch (err) {
      console.error("Error refreshing product list", err);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);
      try {
        setLoadingProducts(true);
        const productsRes = await api.get("/product/names-prices");
        if (productsRes.data.code === 1) setProductList(productsRes.data.additionalDetail);
        setLoadingProducts(false);

        setLoadingCategories(true);
        const categoriesRes = await api.get("/api/category/getCategories");
        if (categoriesRes.data.code === 1) setCategoryList(categoriesRes.data.additionalDetail);
        setLoadingCategories(false);

        setLoadingVendors(true);
        const vendorsRes = await api.get("/product/getAll");
        if (vendorsRes.data.code === 1 && Array.isArray(vendorsRes.data.additionalDetail)) {
          setVendorList(vendorsRes.data.additionalDetail);
        }
        setLoadingVendors(false);

        const customersRes = await api.get("/product/getAllCustomers");
        if (customersRes.data.code === 1) setCustomerList(customersRes.data.additionalDetail);

        const invoiceRes = await api.get("/product/sale-return/next-invoice");
        setInvoiceNumber(invoiceRes.data.nextInvoice);
      } catch (err) {
        console.error("Error loading initial data", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
  const handleWheel = (e) => {
    if (e.target.type === 'number') {
      e.preventDefault();
    }
  };
  const container = document.querySelector('.purchase-table-container');
  if (container) {
    container.addEventListener('wheel', handleWheel, { passive: false });
  }
  return () => {
    if (container) {
      container.removeEventListener('wheel', handleWheel);
    }
  };
}, []);

const removeRow = (index) => {
  // Remove the product
  setProducts(prev => prev.filter((_, i) => i !== index));

  // Re‑index searchTerms and sizeFilters to keep them aligned
  const newSearchTerms = {};
  const newSizeFilters = {};

  Object.keys(searchTerms).forEach(key => {
    const k = parseInt(key, 10);
    if (k < index) newSearchTerms[k] = searchTerms[k];
    else if (k > index) newSearchTerms[k - 1] = searchTerms[k];
  });

  Object.keys(sizeFilters).forEach(key => {
    const k = parseInt(key, 10);
    if (k < index) newSizeFilters[k] = sizeFilters[k];
    else if (k > index) newSizeFilters[k - 1] = sizeFilters[k];
  });

  setSearchTerms(newSearchTerms);
  setSizeFilters(newSizeFilters);
};
  const handleChange = (index, field, value) => {
    const newProducts = [...products];
    newProducts[index][field] = value;

    if (field === "productName") {
      const foundProduct = productList.find(p => p.productName.toLowerCase() === value.toLowerCase());
      if (foundProduct) {
        newProducts[index].price = foundProduct.sellPrice;
        newProducts[index].category = foundProduct.category;
        const categoryName = (foundProduct.category || "").toLowerCase();
        if (categoryName === 'roll' && foundProduct.size) {
          newProducts[index].size = foundProduct.size;
        }
      }
    }

    const currentCategory = (newProducts[index].category || "").toLowerCase();
    if (field === "returnedQuantity" && (currentCategory === "reel" || currentCategory === "tota" || currentCategory === "roll")) {
      const valueNum = parseFloat(value) || 0;
      newProducts[index].size = valueNum;
    }

    if (field === "category") {
      const foundCategory = categoryList.find(c => c.categoryName.toLowerCase() === value.toLowerCase());
      newProducts[index].category = foundCategory ? foundCategory.categoryName : value;
    }

    if (field === "category") {
      const category = value.toLowerCase();
      if (category !== 'box') newProducts[index].boxSize = '';
      if (category !== 'packet') { newProducts[index].ktae = ''; newProducts[index].gram = ''; }
      if (!['packet', 'roll', 'reel', 'tota'].includes(category)) newProducts[index].size = '';
      if (category !== 'reel' && category !== 'tota') newProducts[index].length = '';
    }

    const category = (newProducts[index].category || "").toLowerCase();
    const price = parseFloat(newProducts[index].price) || 0;
    const quantity = parseFloat(newProducts[index].returnedQuantity) || 0;
    const size = parseFloat(newProducts[index].size) || 0;
    const ktae = parseFloat(newProducts[index].ktae) || 0;
    const gram = parseFloat(newProducts[index].gram) || 0;

    if (category === 'packet') {
      newProducts[index].calculatedTotal = ((quantity * size * ktae * gram * price) / 15500).toFixed(2);
    } else if (category === 'roll') {
      newProducts[index].calculatedTotal = (price * size * quantity).toFixed(2);
    } else if (category === 'reel' || category === 'tota') {
      newProducts[index].calculatedTotal = (price * quantity).toFixed(2);
    } else if (category === 'box') {
      newProducts[index].calculatedTotal = (price * quantity).toFixed(2);
    } else {
      newProducts[index].calculatedTotal = (price * quantity).toFixed(2);
    }

    setProducts(newProducts);
  };

  const addRow = () => {
    setProducts([...products, { 
      productName: '', category: '', returnedQuantity: '', price: '', 
      size: '', ktae: '', gram: '', boxSize: '', particular: '', length: '' 
    }]);
  };

  const removeAllRows = () => {
    setProducts([]);
    setGstPercentage("");
  };

const validateForm = () => {
  if (!customerName || customerName.trim() === "") {
    alert("Customer name is required");
    return false;
  }

  if (!products || products.length === 0) {
    alert("At least one product is required");
    return false;
  }

  for (let i = 0; i < products.length; i++) {
    const p = products[i];
    const row = i + 1;

    if (!p.productName || p.productName.trim() === "") {
      alert(`Product name is required (Row ${row})`);
      return false;
    }

    if (!p.category || p.category.trim() === "") {
      alert(`Category is required (Row ${row})`);
      return false;
    }

    if (!p.returnedQuantity || Number(p.returnedQuantity) <= 0) {
      alert(`Returned quantity must be greater than 0 (Row ${row})`);
      return false;
    }

    const category = p.category.toLowerCase();

    if (category === "reel" || category === "tota") {
      if (!p.returnedQuantity || Number(p.returnedQuantity) <= 0) {
        alert(`Quantity is required for ${category} (Row ${row})`);
        return false;
      }
      if (!p.particular || p.particular.trim() === "") {
        alert(`Vendor name is required for ${category} product (Row ${row})`);
        return false;
      }
      if ((category === "reel" || category === "tota") && (!p.length || Number(p.length) <= 0)) {
        alert(`Length is required for ${category} product (Row ${row})`);
        return false;
      }
    }

    if (category === "packet") {
      if (!p.size || Number(p.size) <= 0) {
        alert(`Size is required for packet (Row ${row})`);
        return false;
      }
      if (!p.ktae || Number(p.ktae) <= 0) {
        alert(`Ktae is required for packet (Row ${row})`);
        return false;
      }
      if (!p.gram || Number(p.gram) <= 0) {
        alert(`Gram is required for packet (Row ${row})`);
        return false;
      }
    }

    if (category === "roll") {
      if (!p.size || Number(p.size) <= 0) {
        alert(`Size is required for roll (Row ${row})`);
        return false;
      }
    }

    if (category === "box") {
      if (!p.boxSize || p.boxSize.trim() === "") {
        alert(`Box Size is required for box (Row ${row})`);
        return false;
      }
    }
  }
  return true;
};

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);

    try {
      const formData = new FormData();

      const requestBody = {
        products: products.map(p => {
          const category = p.category.toLowerCase();
          
          if (category === 'box') {
            return {
              productName: p.productName,
              category: p.category,
              returnedQuantity: parseFloat(p.returnedQuantity) || 0,
              price: parseFloat(p.price) || 0,
              invoiceNumber: parseInt(invoiceNumber) || 0,
              returnTime: new Date(invoiceDate).toISOString(),
              size: 0,
              boxSize: p.boxSize || "",
              ktae: null,
              gram: null,
              particular: p.particular || "",
              length: null
            };
          } 
          else if (category === 'packet') {
            return {
              productName: p.productName,
              category: p.category,
              returnedQuantity: parseFloat(p.returnedQuantity) || 0,
              price: parseFloat(p.price) || 0,
              invoiceNumber: parseInt(invoiceNumber) || 0,
              returnTime: new Date(invoiceDate).toISOString(),
              size: parseFloat(p.size) || 0,
              ktae: parseFloat(p.ktae) || 0,
              gram: parseFloat(p.gram) || 0,
              boxSize: null,
              particular: null,
              length: null
            };
          } 
          else if (category === 'roll') {
            return {
              productName: p.productName,
              category: p.category,
              returnedQuantity: parseFloat(p.returnedQuantity) || 0,
              price: parseFloat(p.price) || 0,
              invoiceNumber: parseInt(invoiceNumber) || 0,
              returnTime: new Date(invoiceDate).toISOString(),
              size: parseFloat(p.size) || 0,
              ktae: null,
              gram: null,
              boxSize: null,
              particular: p.particular || "",
              length: null
            };
          } 
          else if (category === 'reel' || category === 'tota') {
            return {
              productName: p.productName,
              category: p.category,
              returnedQuantity: parseFloat(p.returnedQuantity) || 0,
              price: parseFloat(p.price) || 0,
              invoiceNumber: parseInt(invoiceNumber) || 0,
              returnTime: new Date(invoiceDate).toISOString(),
              size: parseFloat(p.returnedQuantity) || 0,
              length: parseFloat(p.length) || 0,
              ktae: null,
              gram: null,
              boxSize: null,
              particular: p.particular || ""
            };
          } 
          else {
            return {
              productName: p.productName,
              category: p.category,
              returnedQuantity: parseFloat(p.returnedQuantity) || 0,
              price: parseFloat(p.price) || 0,
              invoiceNumber: parseInt(invoiceNumber) || 0,
              returnTime: new Date(invoiceDate).toISOString(),
              size: 0,
              ktae: null,
              gram: null,
              boxSize: null,
              particular: p.particular || "",
              length: null
            };
          }
        }),
        invoiceDiscount: parseFloat(generalDiscount) || 0,
        invoiceRent: parseFloat(rent) || 0,
        description,
        customerName,
        gstPercentage: gstPercentage ? parseFloat(gstPercentage) : null,
        returnDate: invoiceDate
      };

      formData.append("request", JSON.stringify(requestBody));
      formData.append("status", "Return");

      if (invoiceImage) formData.append("invoiceImage", invoiceImage);

      const response = await api.post("/product/sell", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data.code === 1) {
        alert("Stock returned successfully");
      } else {
        alert(response.data.additionalDetail);
        setIsSubmitting(false);
        return;
      }

      setCanPrint(true);

      setPrintInvoice({
        invoiceNumber,
        customerName,
        products: JSON.parse(JSON.stringify(products)),
        invoiceDiscount: generalDiscount,
        invoiceRent: rent,
        gstPercentage: gstPercentage || 0,
        grandTotal,
        user: loggedInUser,
        invoiceDate: invoiceDate
      });

      setProducts([{ productName: '', category: '', returnedQuantity: '', price: '', size: '', ktae: '', gram: '', boxSize: '', particular: '', length: '' }]);
      setCustomerName("");
      setSelectedCustomerBalance(null);
      setRent("");
      setGeneralDiscount(0);
      setGstPercentage("");
      setDescription("");
      setInvoiceImage(null);
      setInvoiceDate(new Date().toISOString().split('T')[0]);

      const res = await api.get("/product/sale-return/next-invoice");
      setInvoiceNumber(res.data.nextInvoice);
      
      await refreshProductList();
      await refreshCustomerList();
      
      setIsSubmitting(false);

    } catch (error) {
      console.error(error);
      alert("Failed to save.");
      setIsSubmitting(false);
    }
  };

  let grandTotal = products.reduce((sum, p) => sum + (parseFloat(p.calculatedTotal) || 0), 0);
  if (rent) grandTotal += parseFloat(rent);
  if (generalDiscount) grandTotal -= parseFloat(generalDiscount);

  let gstAmount = 0;
  let subtotalBeforeGst = grandTotal;
  if (gstPercentage && parseFloat(gstPercentage) > 0) {
    gstAmount = grandTotal * parseFloat(gstPercentage) / 100;
    grandTotal += gstAmount;
  }
  grandTotal = grandTotal.toFixed(2);

  const categories = products.map(p => (p.category || "").toLowerCase());
  const showPacketColumns = categories.includes("packet");
  const showRollColumns = categories.some(c => ["roll"].includes(c));
  const showBoxColumns = categories.includes("box");
  const showParticularColumn = true;
  const showWeightLabel = products.some(p => {
    const cat = (p.category || "").toLowerCase();
    return cat === "reel" || cat === "tota" || cat === "roll";
  });
  const hasReelOrTotaOrRoll = products.some(p => {
    const cat = (p.category || "").toLowerCase();
    return cat === "reel" || cat === "tota";
  });
  const showLengthColumn = products.some(p => {
    const cat = (p.category || "").toLowerCase();
    return cat === "reel" || cat === "tota";
  });
  // Show Size column if ANY product needs it (packet, roll, or reel/tota)
  const showSizeColumn = showPacketColumns || showRollColumns || showLengthColumn;

  if (isLoading) {
    return (
      <div className="purchase-table-container" style={{ textAlign: 'center', padding: '50px' }}>
        <div style={{ fontSize: '18px', color: '#0a8938' }}>Loading data...</div>
        <div style={{ marginTop: '10px', color: '#666' }}>Please wait while we load products, categories, and vendors.</div>
      </div>
    );
  }

  return (
    <div className="purchase-table-container">
      <h2 className="page-title" style={{ color: "#0a8938" }}>Sale Return Details</h2>

      {(loadingProducts || loadingCategories || loadingVendors) && (
        <div style={{ textAlign: 'center', padding: '10px', backgroundColor: '#e3f2fd', marginBottom: '10px', borderRadius: '4px' }}>
          ⏳ Refreshing data... {loadingProducts && "Products "} {loadingCategories && "Categories "} {loadingVendors && "Vendors "}
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px", marginBottom: "20px" }}>
        <div>
          <label style={{ fontWeight: "bold" }}>Invoice #</label>
          <input type="text" value={invoiceNumber} readOnly className="read-only-input" />
        </div>
        <div>
          <label style={{ fontWeight: "bold" }}>Invoice Date</label>
          <input type="date" value={invoiceDate} onChange={e => setInvoiceDate(e.target.value)} className="read-only-input" max={new Date().toISOString().split('T')[0]} />
        </div>
        <div>
          <label style={{ fontWeight: "bold" }}>Customer Name</label>
          <input type="text" list="customerNames" value={customerName} onChange={handleCustomerChange} placeholder="Enter Customer Name" className="read-only-input" disabled={isLoading} />
          <datalist id="customerNames">
            {customerList.map((c, i) => (
              <option key={i} value={c.customerName}>
                {c.customerName} {c.currentBalance !== undefined ? `(Balance: ${c.currentBalance})` : ''}
              </option>
            ))}
          </datalist>
          {selectedCustomerBalance !== null && (
            <div style={{ fontSize: '12px', color: '#0a8938', marginTop: '5px' }}>
              Current Balance: Rs {selectedCustomerBalance.toFixed(2)}
            </div>
          )}
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="purchase-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Category</th>
              <th>{showWeightLabel ? "Weight/Quantity" : "Returned Qty"}</th>
              <th>Rate</th>
              {/* SINGLE Size column - shown if packet, roll, or reel/tota products exist */}
              {showSizeColumn && <th>Size</th>}
              {showPacketColumns && (<><th>Ktae</th><th>Gram</th></>)}
              {showBoxColumns && <th>Box Size</th>}
              {showParticularColumn && <th>{hasReelOrTotaOrRoll ? "Vendor Name" : "Particular"}</th>}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, idx) => {
              const category = product.category.toLowerCase();
              const selectedProduct = productList.find(p => p.productName === product.productName);
              const stockQuantity = selectedProduct?.stockQuantity;
              const packetStockByVariant = selectedProduct?.packetStockByVariant;
              const stockByWeight = selectedProduct?.stockByWeight;
              const isPacket = category === "packet";
              const isReelOrTotaOrRoll = category === "reel" || category === "tota" || category === "roll";
              const isReelOrTota = category === "reel" || category === "tota";
              const isRoll = category === "roll";
              
              return (
                <tr key={idx}>
                  <td style={{ position: 'relative' }}>
                    <input
                      list={`products-${idx}`}
                      value={product.productName}
                      onChange={e => handleChange(idx, "productName", e.target.value)}
                      className="read-only-input"
                      placeholder='Enter Product Name'
                      style={{ 
                        borderColor: (() => {
                          const selectedProduct = productList.find(p => p.productName === product.productName);
                          if (!selectedProduct) return '';
                          const cat = (selectedProduct.category || "").toLowerCase();
                          const isReelTotaRoll = cat === 'reel' || cat === 'tota' || cat === 'roll';
                          const isPacket = cat === 'packet';
                          if (isReelTotaRoll && selectedProduct.stockByWeight) {
                            const hasStock = Object.values(selectedProduct.stockByWeight).some(qty => qty > 0);
                            return !hasStock && product.productName ? '#ff4444' : '';
                          }
                          if (isPacket && selectedProduct.packetStockByVariant) {
                            const hasStock = Object.values(selectedProduct.packetStockByVariant).some(qty => qty > 0);
                            return !hasStock && product.productName ? '#ff4444' : '';
                          }
                          return (selectedProduct?.stockQuantity !== undefined && parseFloat(selectedProduct.stockQuantity) <= 0 && product.productName) ? '#ff4444' : '';
                        })(),
                        backgroundColor: (() => {
                          const selectedProduct = productList.find(p => p.productName === product.productName);
                          if (!selectedProduct) return '';
                          const cat = (selectedProduct.category || "").toLowerCase();
                          const isReelTotaRoll = cat === 'reel' || cat === 'tota' || cat === 'roll';
                          const isPacket = cat === 'packet';
                          if (isReelTotaRoll && selectedProduct.stockByWeight) {
                            const hasStock = Object.values(selectedProduct.stockByWeight).some(qty => qty > 0);
                            return !hasStock && product.productName ? '#fff0f0' : '';
                          }
                          if (isPacket && selectedProduct.packetStockByVariant) {
                            const hasStock = Object.values(selectedProduct.packetStockByVariant).some(qty => qty > 0);
                            return !hasStock && product.productName ? '#fff0f0' : '';
                          }
                          return (selectedProduct?.stockQuantity !== undefined && parseFloat(selectedProduct.stockQuantity) <= 0 && product.productName) ? '#fff0f0' : '';
                        })()
                      }}
                    />
                    <datalist id={`products-${idx}`}>
                      {productList.map((p, i) => {
                        const cat = (p.category || "").toLowerCase();
                        const isReelTotaRoll = cat === 'reel' || cat === 'tota' || cat === 'roll';
                        const isPacket = cat === 'packet';
                        if (isReelTotaRoll && p.stockByWeight && Object.keys(p.stockByWeight).length > 0) {
                          const nonZero = Object.entries(p.stockByWeight).filter(([_, qty]) => qty > 0);
                          if (nonZero.length > 0) {
                            return <option key={i} value={p.productName}>{p.productName} [{nonZero.map(([w, q]) => `${w}: ${q}`).join(', ')}]</option>;
                          } else {
                            return <option key={i} value={p.productName}>{p.productName} (Out of Stock)</option>;
                          }
                        } else if (isPacket && p.packetStockByVariant && Object.keys(p.packetStockByVariant).length > 0) {
                          const nonZero = Object.entries(p.packetStockByVariant).filter(([_, qty]) => qty > 0);
                          if (nonZero.length > 0) {
                            return <option key={i} value={p.productName}>{p.productName} [{nonZero.map(([v, q]) => `${v}: ${q}`).join(', ')}]</option>;
                          } else {
                            return <option key={i} value={p.productName}>{p.productName} (Out of Stock)</option>;
                          }
                        } else {
                          return <option key={i} value={p.productName}>{p.productName}{p.stockQuantity !== undefined ? ` (Stock: ${p.stockQuantity})` : ''}{p.category === 'roll' && p.size ? ` [Size: ${p.size}]` : ''}</option>;
                        }
                      })}
                    </datalist>
                    
                    {product.productName && isPacket && selectedProduct && (
                      <div style={{ marginTop: '4px' }}>
                        {(() => {
                          const totalStock = selectedProduct.stockQuantity || 0;
                          const variantEntries = packetStockByVariant ? Object.entries(packetStockByVariant).filter(([_, qty]) => qty > 0) : [];
                          const hasStock = totalStock > 0;
                          if (!hasStock) {
                            return <div style={{ color: '#ff4444', backgroundColor: '#ffebee', padding: '6px 8px', borderRadius: '4px', border: '1px solid #ff4444', fontSize: '11px' }}><strong>⚠️ Out of Stock</strong></div>;
                          }
                          return (
                            <div style={{ color: '#0a8938', backgroundColor: '#f8f9fa', padding: '6px 8px', borderRadius: '4px', border: '1px solid #0a8938', fontSize: '11px' }}>
                              <div><strong>📦 Total Stock: {totalStock}</strong></div>
                              {variantEntries.length > 0 && (
                                <>
                                  <div style={{ fontSize: '10px', marginTop: '4px', color: '#555' }}>Breakdown by variant:</div>
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '2px' }}>
                                    {variantEntries.map(([variant, qty]) => (
                                      <span key={variant} style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '12px', fontSize: '9px', fontWeight: 'bold' }}>{variant}: {qty}</span>
                                    ))}
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}
                    
                    {product.productName && isReelOrTotaOrRoll && stockByWeight && Object.keys(stockByWeight).length > 0 && (
                      <div style={{ fontSize: '10px', color: '#0a8938', marginTop: '2px', fontWeight: '500', backgroundColor: '#e8f5e9', padding: '2px 4px', borderRadius: '4px' }}>
                        📊 {Object.entries(stockByWeight).map(([w, q]) => `${w}: ${q}`).join(', ')}
                      </div>
                    )}
                    
                    {product.productName && !isPacket && !isReelOrTotaOrRoll && stockQuantity !== undefined && (
                      <div style={{ fontSize: '11px', color: stockQuantity <= 0 ? '#ff4444' : '#0a8938', marginTop: '2px', fontWeight: '500' }}>
                        📦 {stockQuantity <= 0 ? 'Out of Stock' : `In Stock: ${stockQuantity}`}
                      </div>
                    )}
                    
                    {isReelOrTotaOrRoll && (!product.returnedQuantity || parseFloat(product.returnedQuantity) <= 0) && product.productName && (
                      <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                        ⚡ Enter {category === 'roll' ? 'meters/units' : 'weight in kg'} in the Quantity column
                      </div>
                    )}
                    {category === 'roll' && !product.size && product.productName && (
                      <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px', fontWeight: '500' }}>
                        ⚠️ Size is required for roll products
                      </div>
                    )}
                    {isReelOrTota && (!product.length || parseFloat(product.length) <= 0) && product.productName && (
                      <div style={{ fontSize: '11px', color: '#ff9800', marginTop: '2px', fontWeight: '500' }}>
                        ⚡ Length is required (e.g., meters)
                      </div>
                    )}
                  </td>

                  <td>
                    <input list={`categories-${idx}`} value={product.category} onChange={e => handleChange(idx, "category", e.target.value)} className="read-only-input" />
                    <datalist id={`categories-${idx}`}>
                      {Array.isArray(categoryList) && categoryList.map((c, i) => <option key={i} value={c.categoryName} />)}
                    </datalist>
                  </td>

                  <td>
                    <input type="number" value={product.returnedQuantity} onChange={e => handleChange(idx, "returnedQuantity", e.target.value)} className="read-only-input" placeholder={(category === "reel" || category === "tota") ? "Weight in kg" : (category === "roll" ? "Quantity in meters" : "Quantity")} step={(category === "reel" || category === "tota") ? "1" : "0.01"} />
                  </td>

                  <td>
                    <input type="number" value={product.price} onChange={e => handleChange(idx, "price", e.target.value)} className="read-only-input" />
                  </td>

                  {/* SINGLE Size column - shows size for packet/roll and length for reel/tota */}
                  {/* SINGLE Size column - shows size for packet, roll, and reel/tota */}
{showSizeColumn && (
  <td>
    {/* ---------- INPUT FIELD ---------- */}
    {isPacket || isRoll ? (
      <input 
        type="number" 
        value={product.size || ""} 
        onChange={e => handleChange(idx, "size", e.target.value)} 
        className="read-only-input" 
        disabled={isLoading} 
        placeholder={isRoll ? "Size *" : "Size"}
        style={{ 
          borderColor: (isRoll && !product.size && product.productName) ? '#ff4444' : '',
          fontWeight: isRoll ? '500' : 'normal',
          backgroundColor: (isRoll && !product.size && product.productName) ? '#fff0f0' : ''
        }}
        onWheel={(e) => e.preventDefault()}
      />
    ) : isReelOrTota ? (
      <input 
        type="number" 
        step="any" 
        value={product.length || ""} 
        onChange={e => handleChange(idx, "length", e.target.value)} 
        className="read-only-input" 
        disabled={isLoading} 
        placeholder="Length (m)"
        style={{ 
          borderColor: (!product.length && product.productName) ? '#ff4444' : '',
          fontWeight: '500'
        }}
        onWheel={(e) => e.preventDefault()}
      />
    ) : (
      <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />
    )}

    {/* ---------- VALIDATION MESSAGES ---------- */}
    {isRoll && !product.size && product.productName && (
      <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px', fontWeight: '500' }}>
        ⚠️ Size is required for roll products
      </div>
    )}

    {/* ---------- IMPROVED STOCK DISPLAY (PILLS) ---------- */}
    {selectedProduct && selectedProduct.stockByWeight && (
      <div style={{
        marginTop: '6px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {(() => {
          let entries = [];
          if (isReelOrTota && product.length) {
            // Reel/Tota: filter by length
            entries = Object.entries(selectedProduct.stockByWeight)
              .filter(([key, qty]) => {
                const match = key.match(/\|\s*(\d+(?:\.\d+)?)m/);
                return match && parseFloat(match[1]) === parseFloat(product.length) && qty > 0;
              });
          } else if (isRoll && product.size) {
            // Roll: filter by size
            entries = Object.entries(selectedProduct.stockByWeight)
              .filter(([key, qty]) => {
                const match = key.match(/^(\d+(?:\.\d+)?)/);
                return match && parseFloat(match[1]) === parseFloat(product.size) && qty > 0;
              });
          }

          if (entries.length === 0) {
            // If a size/length is entered but no stock matches, show "Out of Stock"
            if ((isReelOrTota && product.length) || (isRoll && product.size)) {
              return <span style={{ color: '#ff4444', fontWeight: '500', fontSize: '12px' }}>Out of Stock</span>;
            }
            // Otherwise show nothing (user hasn't entered size/length yet)
            return null;
          }

          // Render each stock entry as a pill
          return entries.map(([display, qty]) => (
            <span key={display} style={{
              background: '#e8f5e9',
              padding: '1px 8px',
              borderRadius: '16px',
              fontSize: '11px',
              fontWeight: '500',
              color: '#1e7e34',
              whiteSpace: 'nowrap',
              border: '1px solid #a5d6a7',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '3px'
            }}>
              <span>{display}</span>
              <strong style={{ fontSize: '12px' }}>{qty}</strong>
            </span>
          ));
        })()}
      </div>
    )}
  </td>
)}

                  {showPacketColumns && (
                    <>
                      <td>
                        {isPacket ? <input type="number" value={product.ktae || ""} onChange={e => handleChange(idx, "ktae", e.target.value)} className="read-only-input" placeholder="Ktae" /> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />}
                      </td>
                      <td>
                        {isPacket ? <input type="number" value={product.gram || ""} onChange={e => handleChange(idx, "gram", e.target.value)} className="read-only-input" placeholder="Gram" /> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />}
                      </td>
                    </>
                  )}

                  {showBoxColumns && (
                    <td>
                      {category === "box" ? <input type="text" value={product.boxSize || ""} onChange={e => handleChange(idx, "boxSize", e.target.value)} className="read-only-input" placeholder="Box Size" /> : <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="N/A" />}
                    </td>
                  )}

                  {/* Particular Column - Show for all categories except roll */}
                  {showParticularColumn && (
                    <td>
                      {category !== 'roll' ? (
                        (category === 'reel' || category === 'tota') ? (
                          <>
                            <input type="text" list={`vendors-${idx}`} value={product.particular || ""} onChange={e => handleChange(idx, "particular", e.target.value)} className="read-only-input" placeholder="Select Vendor Name" style={{ borderColor: (!product.particular && product.productName) ? '#ff4444' : '' }} />
                            <datalist id={`vendors-${idx}`}>
                              {vendorList.map(vendor => <option key={vendor.id} value={vendor.vendorName} />)}
                            </datalist>
                            {!product.particular && product.productName && <div style={{ fontSize: '11px', color: '#ff4444', marginTop: '2px' }}>⚠️ Vendor name required</div>}
                            {product.particular && <div style={{ fontSize: '10px', color: '#0a8938', marginTop: '2px' }}>✅ Returning to vendor: {product.particular}</div>}
                          </>
                        ) : (
                          <input type="text" value={product.particular || ""} onChange={e => handleChange(idx, "particular", e.target.value)} className="read-only-input" placeholder="Particular" />
                        )
                      ) : (
                        <input type="text" value="" className="read-only-input" disabled style={{ backgroundColor: '#f0f0f0' }} placeholder="Not applicable for Roll" />
                      )}
                    </td>
                  )}
                  <td>
  <button
    onClick={() => removeRow(idx)}
    className="remove-row-btn"
    title="Remove this row"
  >
    ✕
  </button>
</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "20px", marginTop: "20px" }}>
        <div><label style={{ fontWeight: "bold" }}>Discount</label><input type="number" value={generalDiscount} onChange={e => setGeneralDiscount(parseFloat(e.target.value) || 0)} className="read-only-input" /></div>
        <div><label style={{ fontWeight: "bold" }}>Rent</label><input type="number" value={rent} onChange={e => setRent(parseFloat(e.target.value) || 0)} className="read-only-input" /></div>
        <div><label style={{ fontWeight: "bold" }}>GST % (Optional)</label><input type="number" value={gstPercentage} onChange={e => setGstPercentage(e.target.value)} placeholder="e.g., 18" className="read-only-input" step="0.01" min="0" max="100" /></div>
        <div></div>
      </div>

      {gstPercentage && parseFloat(gstPercentage) > 0 && (
        <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef", fontSize: "14px" }}>
          <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
            <span><strong>Subtotal:</strong> Rs {subtotalBeforeGst.toFixed(2)}</span>
            <span><strong>GST ({gstPercentage}%):</strong> Rs {gstAmount.toFixed(2)}</span>
            <span><strong>Total after GST:</strong> Rs {(subtotalBeforeGst + gstAmount).toFixed(2)}</span>
          </div>
        </div>
      )}

      <div style={{ marginTop: "20px" }}>
        <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px" }}>Invoice Image (optional)</label>
        <div style={{ border: "2px dashed #0a8938", padding: "20px", borderRadius: "8px", textAlign: "center", cursor: "pointer", backgroundColor: "#f9f9f9", color: "#555", width: "100%", boxSizing: "border-box" }} onClick={() => document.getElementById("invoiceImage").click()}>
          {invoiceImage ? invoiceImage.name : "Click or Drag to Upload Invoice Image"}
          <input id="invoiceImage" type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <label style={{ fontWeight: "bold" }}>Description</label>
        <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Enter Description" className="read-only-input" />
      </div>

      {totalQuantity > 0 && (
        <div style={{ marginTop: "10px", textAlign: "right", fontSize: "16px", fontWeight: "500", color: "#0a8938" }}>
          Total Quantity: {totalQuantity} {products.some(p => {
            const cat = (p.category || "").toLowerCase();
            return cat === "reel" || cat === "tota";
          }) ? "kg" : (products.some(p => (p.category || "").toLowerCase() === "roll") ? "meters" : "units")}
        </div>
      )}

      <div style={{ marginTop: "20px", textAlign: "right", fontSize: "20px", fontWeight: "bold", color: "#0c6303" }}>
        Amount Payable: Rs {grandTotal} 
        {gstPercentage && parseFloat(gstPercentage) > 0 && (
          <div style={{ fontSize: "14px", color: "#666", marginTop: "5px" }}>(Includes Rs {gstAmount.toFixed(2)} GST @ {gstPercentage}%)</div>
        )}
      </div>

      <div className="table-actions" style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <button onClick={removeAllRows} className="remove-btn">Remove All</button>
        <button onClick={handleSubmit} className="save-btn" disabled={isSubmitting} style={{ opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}>{isSubmitting ? 'Saving...' : 'Save All'}</button>
        <button onClick={addRow} className="add-btn">Add Product</button>
        <button onClick={handlePrintClick} className="print-btn" disabled={!canPrint}>Print</button>
      </div>

      <div style={{ position: "absolute", top: "-9999px" }}>
        <UniversalInvoicePrint ref={printRef} invoice={printInvoice} type="saleReturn" />
      </div>
    </div>
  );
}

export default SaleRevertStock;